/* tslint:disable */

declare var Object: any;
export interface ReportdownloadInterface {
  id?: number;
}

export class Reportdownload implements ReportdownloadInterface {
  id: number;
  constructor(data?: ReportdownloadInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Reportdownload`.
   */
  public static getModelName() {
    return "Reportdownload";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Reportdownload for dynamic purposes.
  **/
  public static factory(data: ReportdownloadInterface): Reportdownload{
    return new Reportdownload(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Reportdownload',
      plural: 'reportdownloads',
      properties: {
        id: {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Reportdownload.ts